/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Top_RightInputs */



/**
* | output |
* | --- |
* | "Position Top Right" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Top_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_top_right = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Top_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Top_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner en haut a droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position Oben rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione in alto a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расположение: Верхний правый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición superior derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置右上角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右上の位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊपरी दाएं कोने में स्थित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Canto superior direito")
	return /** @type {LocalizedString} */ ("Position Top Right")
});